import React from "react";
import Header from "./Header";
import Particles from "./Particles";
import Skills from './Skills1';
import Footer from './Footer'

const Home = () => {
  return (
    <React.Fragment>
      <Header />
      <Particles />
      <Skills />
      <Footer />
    </React.Fragment>
  );
};

export default Home;
